module.exports = __webpack_public_path__ + "img/admin_apply03.ec42d8be.png";